import classNames from 'classnames';
import * as React from 'react';
import { compose, pure } from 'recompose';
import MuiSelect from '@material-ui/core/Select';
import { createStyles, withStyles } from '@material-ui/styles';
import { renderFromHelper } from '../renderFieldError';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
const styles = (theme) => createStyles({
    root: {
        width: '100%',
    },
    inputRoot: {
        color: 'currentColor',
    },
    selectLabelClass: {
        minWidth: 100,
        color: 'currentColor',
        fontSize: theme.font.size.mediumSmall,
        fontWeight: theme.font.weight.normal,
        height: 16,
    },
    icon: {
        color: 'currentColor',
        opacity: 0.54,
    },
    select: {
        paddingTop: 7,
        paddingBottom: 2,
    },
});
const Select = (props) => {
    const { input, classes, className, label, required, meta: { touched, error } = { touched: false, error: false }, children, testId = 'Select', ...others } = props;
    const { selectLabelClass, inputRoot, ...overrides } = classes;
    const labelBox = label && React.createElement(InputLabel, { shrink: true }, label);
    return (React.createElement(FormControl, { "data-testid": `${testId}`, required: required, error: touched && Boolean(error), fullWidth: true },
        labelBox,
        React.createElement(MuiSelect, Object.assign({ "data-testid": `${testId}-input` }, input, { fullWidth: true, classes: overrides, className: classNames(inputRoot, className) }, others), children),
        renderFromHelper({ touched, error })));
};
const ComposedSelect = compose(withStyles(styles, { withTheme: true }), pure)(Select);
ComposedSelect.displayName = 'Select';
export default ComposedSelect;
//# sourceMappingURL=Select.js.map